import { ChevronLeft, ChevronRight, Copy, Check } from "lucide-react";
import { useState } from "react";
import { BookText, ChevronDown, ChevronUp } from "lucide-react";
import PC from "./../../assets/Guideline/PCguideline.png";
import mobile from "./../../assets/Guideline/mobileguideline.png";

function ImageUrl({
  onPrev,
  onNext,
  guideline,
}: {
  onPrev: () => void;
  onNext: () => void;
  guideline: any;
}) {
  const [openSection, setOpenSection] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const [showCopied, setShowCopied] = useState(false);

  const toggleSection = (section: any) => {
    setOpenSection((prev) => (prev === section ? null : section));
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(guideline.image_url_tracking);
    setIsCopied(true);
    setShowCopied(true);
    setTimeout(() => setShowCopied(false), 2000);
  };

  return (
    <>
      <div className="">
        <div className="border pb-2 mb-5 flex flex-col gap-1 ps-3 bg-gray-100 rounded-lg pt-5">
          <h2 className="text-sm font-bold text-gray-800 mb-1">
            협찬 배너 URL 받기
          </h2>
          <p className="text-xs text-gray-400 mb-4">
            URL링크를 복사후 등록방법을 확인해주세요.
          </p>
        </div>
        <div className="">
          <div className="flex items-start mb-4 ml-2 gap-1">
            <div className="flex flex-col gap-3 items-center mr-2">
              <div className="w-6 h-6 text-xs rounded-full flex items-center justify-center bg-[#46B6D0] text-white">
                1
              </div>
              <div
                className={`h-[10vh] w-[1px] ${
                  isCopied ? "bg-[#46B6D0]" : "bg-gray-200"
                }`}
              ></div>
            </div>
            <div className="flex-1">
              <p className="text-[#46B6D0] text-sm pb-3">협찬배너 URL.</p>
              <div className="text-xs">
                <div className="flex items-center justify-between pb-1">
                  <p>URL 복사</p>
                </div>
                <div className="flex items-center gap-2 relative">
                  <input
                    className="flex-1 p-2 border rounded text-xs w-full outline-none focus:border-[#46B6D0] focus:ring-0"
                    placeholder={guideline.image_url_tracking}
                    value={guideline.image_url_tracking}
                    readOnly
                    onFocus={(e) => e.target.select()}
                  />
                  <div className="relative">
                    <button
                      className={`p-2 rounded border transition-all duration-200 ${
                        showCopied
                          ? "bg-green-100 border-green-300 text-green-600"
                          : "bg-gray-100 border-gray-300 text-[#0F1E6C] hover:bg-gray-200"
                      }`}
                      onClick={handleCopy}
                    >
                      {showCopied ? (
                        <Check className="w-4 h-4" />
                      ) : (
                        <Copy className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-start ml-2">
            <div className="flex flex-col items-center mr-2">
              <div
                className={`w-6 h-6 text-xs rounded-full flex items-center justify-center ${
                  isCopied
                    ? "bg-[#46B6D0] text-white"
                    : "bg-gray-200 text-white"
                }`}
              >
                2
              </div>
            </div>
            <div className="w-full">
              <p
                className={`pt-1 text-sm ${
                  isCopied ? "text-[#46B6D0]" : "text-gray-300"
                }`}
              >
                협찬배너 등록방법
              </p>
              {isCopied && (
                <div className="space-y-4 pt-2">
                  {/* PC Section */}
                  <div className="text-xs">
                    <div
                      className="pt-2 flex justify-between items-center border-b pb-1 cursor-pointer transition-colors"
                      onClick={() => toggleSection("pc")}
                    >
                      <p
                        className={`pb-2 transition-colors ${
                          openSection === "pc" ? "" : "text-black"
                        }`}
                      >
                        PC에서 등록하기
                      </p>
                      {openSection === "pc" ? (
                        <ChevronUp className="w-5 h-5 transition-colors" />
                      ) : (
                        <ChevronDown className="w-5 h-5 text-black transition-colors" />
                      )}
                    </div>
                    {openSection === "pc" && (
                      <img
                        src={PC}
                        alt="PC 가이드"
                        className="mt-2 rounded shadow border"
                      />
                    )}
                  </div>

                  {/* Mobile Section */}
                  <div className="text-xs">
                    <div
                      className="flex justify-between items-center border-b pb-1 cursor-pointer transition-colors"
                      onClick={() => toggleSection("mobile")}
                    >
                      <p
                        className={`pb-2 transition-colors ${
                          openSection === "mobile" ? "" : "text-black"
                        }`}
                      >
                        모바일에서 등록하기
                      </p>
                      {openSection === "mobile" ? (
                        <ChevronUp className="w-5 h-5 transition-colors" />
                      ) : (
                        <ChevronDown className="w-5 h-5 text-black transition-colors" />
                      )}
                    </div>
                    {openSection === "mobile" && (
                      <img
                        src={mobile}
                        alt="모바일 가이드"
                        className="mt-2 rounded shadow border"
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="max-w-xl mx-auto fixed z-20 bottom-0 left-0 right-0 bg-white border-t justify-between px-4 py-3 flex gap-2">
          <div
            onClick={onPrev}
            className="flex pr-2 text-sm rounded-full w-1/4 bg-[#F4F5FF] text-[#0F1E6C] h-11 justify-center items-center"
          >
            <ChevronLeft />
            <div className="font-semibold">이전</div>
          </div>

          <div
            onClick={() => onNext()}
            className="flex ps-2 text-sm rounded-full w-1/4 bg-[#F4F5FF] text-[#0F1E6C] h-11 justify-center items-center"
          >
            <div className="font-semibold"> 다음</div>
            <ChevronRight className=""></ChevronRight>
          </div>
        </div>
      </div>
    </>
  );
}

export default ImageUrl;
